import { Component, OnInit, Renderer } from '@angular/core';
import { CommonService } from '../service/common.service';
import { MonshinService } from '../service/monshin.service';
import { ShareService } from '../service/share.service';
import { UsersService } from '../service/users.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { AnswerStatus, Mode } from '../app.constant';

declare let $;
declare let jsPDF;
declare let html2canvas;

@Component({
  selector: 'app-a0112-confirm-preview',
  templateUrl: './a0112-confirm-preview.component.html',
  styleUrls: ['./a0112-confirm-preview.component.css']
})
export class A0112ConfirmPreviewComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private usersService: UsersService,
    private shareService: ShareService,
    private renderer: Renderer,
    private router: Router,
    private monshinService: MonshinService,
    private location: Location,
  ) { }

  categoryInfo: any;
  answerUserInfo: any;
  settingMonsinInfo:any;
  questionList: any;
  resultList: any;
  startResultList: any;
  inspectionList :any[];
  userInfo: any;
  mode: number;
  MODE = Mode;

  ngOnInit() {
    //component読み込みのため、スクロール位置を固定で一番上に
    window.scrollTo(0, 0);

    this.answerUserInfo = this.shareService.getAnswerUserInfo();
    this.settingMonsinInfo = this.shareService.getSettingMonsinInfo();
    this.categoryInfo = this.shareService.getCategoryInfoShare();
    this.resultList = this.shareService.getResultListShare();
    this.startResultList = this.shareService.getStartResultListShare();
    this.inspectionList =this.shareService.getInspectionListShare();
    this.userInfo = this.usersService.userinfo;
    this.mode = this.shareService.getModeShare();

    if (this.resultList == null || this.resultList.length == 0
      || this.startResultList == null || this.categoryInfo == null) {
      this.commonService.modalOpens(90001, modalresult => {
      });
      this.router.navigate(["/admin"]);
    }
  }

  save() {
    this.commonService.modalOpens(50001, modalresult => {
      if (modalresult == "OK") {
        //結果データの結合
        //念のため値渡し

        let main = JSON.parse(JSON.stringify(this.resultList));
        let start = JSON.parse(JSON.stringify(this.startResultList));
        let allResultList = start.concat(main);

        let categoryParam = {
          "t_person_id": this.categoryInfo["t_person_id"],
          "t_event_id": this.categoryInfo["t_event_id"],
          "t_question_category_id": this.categoryInfo["t_question_category_id"],
          "m_question_category_id": this.categoryInfo["m_question_category_id"],
          "t_answer_status_id": this.categoryInfo["t_answer_status_id"] === undefined ? null : this.categoryInfo["t_answer_status_id"],
          "m_language_id": this.answerUserInfo["m_language_id"],//回答者情報から言語IDを渡す
          // "m_language_id" : this.categoryInfo["m_language_id"],
        };

        this.monshinService.saveResult(categoryParam, allResultList, AnswerStatus.DONE).subscribe((res: Response) => {

          if (res["fuel_status"] == "OK") {
            this.commonService.modalOpens(10001, modalresult => {
              if (modalresult == "OK") {
                this.shareService.refleshAll();
                this.router.navigate(["/person/" + this.categoryInfo.t_event_id]);
              }
            });
          }else if (res["fuel_status"] == "NG") {
            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
          }else{
            this.commonService.modalOpens(11003,modalresult=>{});
          }
        }, error => {
          this.commonService.modalOpens(error, modalresult => { });
        });
      }
    });

  }

  goBack(): void {
    this.location.back();
  }

  reset() {
    this.commonService.modalOpens(50005, modalresult => {
      if (modalresult == "OK") {
        //エラーリストのリフレッシュ
        this.shareService.refleshErrorListShare();

        //管理画面から渡された情報の再取得
        this.categoryInfo = this.shareService.getCategoryInfoShare();
        this.startResultList = this.shareService.getStartResultListShare();

        if (this.startResultList.length > 0) {
          //値渡しでなければ、初期化できなくなる
          this.shareService.setStartQuestionListShare(JSON.parse(JSON.stringify(this.shareService.getInitialStartQuestionListShare())));
          this.shareService.refleshStartResultListShare();
          //基本情報があるので、遷移先も基本情報
          this.router.navigate(["/answer-preview/start"]);
        } else {
          //基本情報がない場合、この画面から再読み込みを行う
          this.shareService.refleshQuestionListShare();
          this.router.navigate(["/answer-preview/main"]);
        }

      }
    });

  }

  download() {
    /**
     * 1ページ分の画像切り出し
     * 完成だがメモリ使用量えぐい
     * canvas調整してみる
     */
    html2canvas($("#out-put"), {
      onrendered: function (canvas) {

        const pageWidth = 210;//a4
        const pageHeight = 295;//a4

        const xMargin = 10;//1辺のマージン
        const yMargin = 10;//1辺のマージン

        // const backHeight = 20; //改ページ時に巻き戻す高さ

        let imgWidth = pageWidth - (xMargin * 2);//左右分のマージン
        let oneceImageHeight = pageHeight - (yMargin * 2);//上下分のマージン
        let ratio = imgWidth / canvas.width;//画像の比率
        let imgHeight = Math.round(canvas.height * ratio);//実際に出力する際の画像全ての高さ
        let originOneceHeight = Math.round(oneceImageHeight / ratio);//オリジナル画像の1ページ分の高さ
        let percent = 1;//この値を下げれば画像は荒くなるが処理が早くなる ex:0.7
        let tmpCanvasWidth = Math.round(canvas.width * percent);
        let tmpCanvasHeight = Math.round(originOneceHeight * percent);

        let pageCount = Math.ceil(imgHeight / oneceImageHeight);//切り上げしたページ数 -1はデフォルトで1枚目は用意されているため

        let xPosition = xMargin;//描画開始位置(x)
        let yPosition = yMargin;//描画開始位置(y)

        let doc = new jsPDF('p', 'mm');

        for (let i = 0; i < pageCount; i++) {
          //デフォルトで1枚目は用意されているため
          if (i > 0) {
            //ページ追加
            doc.addPage();
          }

          //1ページ分のcanvasを用意
          let onePageCanvas = document.createElement("canvas");
          onePageCanvas.setAttribute('width', tmpCanvasWidth.toString());
          onePageCanvas.setAttribute('height', tmpCanvasHeight.toString());
          let ctx = onePageCanvas.getContext('2d');
          let canvasDataURL = null;
          if (pageCount > 1) {
            //2ページにかけての出力の場合
            //もととなる画像から1ページ分の画像を取り出す
            //drawImage(もととなる画像, 基のx開始, 基のy開始, 基のx終了, 基のy終了, 新のx開始, 新のy開始, 新のx終了, 新のy終了)
            ctx.drawImage(canvas, 0, (i * originOneceHeight), canvas.width, originOneceHeight, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
            canvasDataURL = onePageCanvas.toDataURL("image/png");
            //書き出すページを設定
            doc.setPage(i + 1);

            //画像をPDFに書き出し
            //addImage(書き出す画像, 画像形式, 書き出しのx開始, 書き出しのy開始, 書き出しのx終了, 書き出しのy終了) <- 比率になる
            doc.addImage(canvasDataURL, 'PNG', xPosition, yPosition, imgWidth, oneceImageHeight);
          } else {
            //Edge対応
            //1ページのみに収まる場合の処理
            canvasDataURL = canvas.toDataURL("image/png");
            doc.addImage(canvasDataURL, 'PNG', xPosition, yPosition, imgWidth, imgHeight);
          }

          //メモリ開放（どれほどの効果があるかはわからない）
          onePageCanvas = null;
          ctx.clearRect(0, 0, tmpCanvasWidth, tmpCanvasHeight)

        }

        //PDFダウンロード
        doc.save('result.pdf');

      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/a0112-answer-preview/a0112-confirm-preview.component.ts